import React from 'react';
import JsonApi from "../../api/jsonApi";
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";
import trim from "lodash/trim";
import {connect} from "react-redux";

import 'react-intl-tel-input/dist/main.css';
import {browserIsSafari} from "../../misc/helpers";
import OnScreenKeyboard from './OnScreenKeyboard/keyboard';
import Analytics from './../../analytics';
import misc from '../../misc/misc';
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import store from '../../store';
import LookUserPhoneInput from "../look/user/lookUserPhoneInput";
import {changeUserInfo} from "../../actions/actionFunctions";
//import autoPrefixer from 'gulp-autoprefixer';

const steps = {
  VerifyPhoneNumber: 0,
  TermsAndConditions: 1,
  UpdatePhone: 2,
  Updated: 3,
  Verified: 4
};

//const phoneUtil = PhoneNumberUtil.getInstance();

export const getPreferredCountries = () => {
  const {fabricatorState} = store.getState();
  if (fabricatorState.isCaesarStone && (fabricatorState.settings.currency === "AUD" || fabricatorState.settings.currency === "AUS")) {
    return ["au", "us", "gb", "ca"]
  }
  if (fabricatorState.isLixil) {
    return ["us", "gb", "ca"]
  }
  switch(fabricatorState.settings.currency) {
    case "CAD":
      return fabricatorState.isLowes ? ["ca"] : ["ca", "us", "gb", "pa", "es"];
    default:
      return ["us", "gb", "ca", "pa", "es"];
  }
}

class TwoFactorAuthClass extends React.Component {
  static propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    // (cancel = true, updatePhone = null)
    onClose: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      step: steps.VerifyPhoneNumber,
      authCode: '',
      validating: false,
      valid: true,
      phoneUpdateError: false,
      oldPhoneNumber: "",
      oldCountry: {},
    };

    this.handleResendSMS();
  }

  setStep = (step) => {
    this.setState({step});
  };

  componentDidMount() {
    this.setOldValues();
  }

  setOldValues() {
    const {phoneNumber, country} = this.props;
    this.setState({oldPhoneNumber: phoneNumber, oldCountry: country})
  }

  render() {
    return (
      <div className="TwoFactorAuth-popup-overlay">
        {this.getDialog()}
      </div>
    );
  }

  getDialogContent = () => {
    let content = {
      title: "Invalid Step",
      content: null,
      footer: null
    };
    switch (this.state.step) {
      case steps.VerifyPhoneNumber:
        content = this.getVerifyPhoneNumberContent();
        break;
      case steps.TermsAndConditions:
        content = this.getTermsAndConditionsContent();
        break;
      case steps.UpdatePhone:
        content = this.getUpdatePhoneContent();
        break;
    }
    return content;
  };

  sendAuthenticationRequest = (token, to, type, message) => {
    if (message) {
      loaderEnable(null, message);
      setTimeout(() => {
        loaderDisable()
      }, 3000);
    }
    return JsonApi.sendAuthenticationRequest(token, to, type);
  };

  handleResendSMS = () => {
    Analytics.sendClickEvent("resend-sms");
    JsonApi.generateAuthenticationToken()
    .then((t) => {
      var token = t.data ? t.data : t;
      this.setState({token});
      this.sendAuthenticationRequest(token, `+${this.props.country.dialCode + this.props.phoneNumber}`, 1, "loader.authenticationSmsSendTitle");
    }).catch(() => this.props.onClose(false, this.props.phoneNumber));
  };

  handleResendVoice = () => {
    Analytics.sendClickEvent("resend-voice");
    JsonApi.generateAuthenticationToken()
    .then((t) => {
      var token = t.data ? t.data : t;
      this.setState({token});
      this.sendAuthenticationRequest(token, `+${this.props.country.dialCode + this.props.phoneNumber}`, 2, 'loader.authenticationCallBackTitle');
    }).catch(() => this.props.onClose(false, this.props.phoneNumber));
  };

  handleCheckVerificationCode = (e) => {
    const authCode = trim(e.target.value).replace(/[^0-9]/g, "");
    this.setState({authCode});
    if (authCode.length === 6) {
      this.setState({validating: true}, () => {
        JsonApi.validateAuthenticationRequest(this.state.token, authCode, this.props.phoneNumber)
          .then((success) => {
            if (success.data) {
              this.handlePostPhoneNumberUpdated();
              Analytics.sendEvent("PhoneVerification", "Success");
              this.setStep(steps.Verified);
              window.setTimeout(() => this.props.onClose(false, this.props.phoneNumber), 3750);
            } else
              Analytics.sendEvent("PhoneVerification", "Failure");
              this.setState({valid: false, validating: false}); //, validating: false
          });
      });
    }
  };

  handlePostPhoneNumberUpdated = () => {
    Analytics.sendClickEvent("phone-number-update");
  };

  handleUpdatePhoneNumber = () => {
    const {country} = this.props;
    var iso2 = country.iso2 || "US";
    if (misc.isPhoneNumber(this.props.phoneNumber, iso2.toUpperCase())) {
      this.handlePostPhoneNumberUpdated();
      this.setStep(steps.VerifyPhoneNumber);
      this.setState({authCode: ""}); // erase previous
      this.setOldValues();
      this.handleResendSMS();
    } else {
      this.setState({phoneUpdateError: true});
    }
  };

  revertUserValues = () => {
    this.props.changeUserInfo({
      phoneNumber: this.state.oldPhoneNumber,
      country: this.state.oldCountry,
    }); // set previous values on back click
  }

  handleBackClick = () => {
    this.revertUserValues(); // set previous values on back click
    this.setStep(steps.VerifyPhoneNumber);
  }

  getVerifyPhoneNumberContent = () => {
    const {intl} = this.props;
    const {fabricatorState} = store.getState();
    return {
      title: intl.formatMessage({id: "twoFA.title"}),
      content: (
        <div className="TwoFactorAuth-popup-overlay-content">
          <input type="text"
                 value={this.state.authCode}
                 className={"TwoFactorAuth-popup-overlay-content-input " + (this.state.valid === false ? ' TwoFactorAuth-popup-overlay-content-input-invalid' : '')}
                 placeholder="Verification Code"
                 onChange={this.handleCheckVerificationCode}
                 id='two-fa'/>
          <OnScreenKeyboard inputId="two-fa" setValue={(v) => this.handleCheckVerificationCode({target: {value: v}})} type="numeric"/>
          {!this.state.valid
            ? <div className="TwoFactorAuth-popup-overlay-content-invalid"><FormattedMessage id="twoFA.invalidCode" /></div>
            : null}
          {this.state.validating
            ? <img src="/content/views/quickquote-v3/images/icons/loading-spinner-blue.svg" alt="Validating..."
                   className="TwoFactorAuth-popup-overlay-content-loading"/>
            : null}
          <div className="TwoFactorAuth-popup-overlay-content-text text-center">
            <FormattedMessage id="twoFA.message"/>
            <span className="TwoFactorAuth-popup-overlay-content-phone"> {`+${this.props.country.dialCode} ${this.props.phoneNumber}`}</span>
            {/*Please enter it or choose to receive a call with your verification code to unlock.*/}
          </div>
          <div className="TwoFactorAuth-popup-overlay-back-button" onClick={() => this.setStep(steps.UpdatePhone)}>
            <FormattedMessage id="twoFA.updatePhoneNumber"/>
          </div>
          <div className="TwoFactorAuth-popup-overlay-content-actions">
            <div className="TwoFactorAuth-popup-overlay-content-actions-button"
                 onClick={() => this.handleResendSMS()}><FormattedMessage id="twoFA.resendCode"/></div>
            <div className="TwoFactorAuth-popup-overlay-content-actions-button"
                 onClick={() => this.handleResendVoice()}><FormattedMessage id="twoFA.receiveCall"/></div>
          </div>
          {fabricatorState.isLowes ? null : (
            <div className="TwoFactorAuth-popup-overlay-content-text TwoFactorAuth-popup-overlay-content-text--secondary">
              <FormattedMessage id="twoFA.additionalText"/>
            </div>
          )}
        </div>
      ),
      footer: (
        <div className="TwoFactorAuth-popup-overlay-footer TwoFactorAuth-popup-overlay-footer--small">
          <div className="TwoFactorAuth-popup-overlay-footer-terms"
               onClick={() => this.setStep(steps.TermsAndConditions)}><FormattedMessage id="twoFA.termsAndConditions"/></div>
        </div>
      )
    }
  };

  getTermsAndConditionsContent = () => {
    const {intl} = this.props;
    return {
      title: intl.formatMessage({id: "twoFA.termsAndConditions"}),
      content: (
        <div className="TwoFactorAuth-popup-overlay-content">
          <div className="TwoFactorAuth-popup-overlay-content-text TwoFactorAuth-popup-overlay-content-text--terms">
            <FormattedMessage id="twoFA.termsAndConditionsText"/>
          </div>
        </div>
      ),
      footer: (
        <div className="TwoFactorAuth-popup-overlay-footer">
          <div className="TwoFactorAuth-popup-overlay-footer-actions">
            <div className="TwoFactorAuth-popup-overlay-footer-actions-button-green"
                 onClick={() => this.setStep(steps.VerifyPhoneNumber)}>
              <FormattedMessage id="twoFA.continue"/>
            </div>
          </div>
        </div>
      )
    };
  };

  getUpdatePhoneContent = () => {
    const {intl} = this.props;
    return {
      title: intl.formatMessage({id: "twoFA.updatePhoneNumber"}),
      content: (
        <div className="TwoFactorAuth-popup-overlay-content">
          <div className="TwoFactorAuth-popup-overlay-content-text-title">
            <FormattedMessage id="twoFA.enterYourPhoneTitle"/>
          </div>
          <div className="TwoFactorAuth-popup-overlay-content-text">
            <LookUserPhoneInput property="phoneNumber"
                                isActive={false}
                                inputsValidated={true}
                                isUserPopup={true}
                                placeholder="userPopup.inputPlaceholders.phone"/>
          </div>
          {this.state.phoneUpdateError ? (
            <div className="TwoFactorAuth-popup-overlay-content-error">
              <FormattedMessage id="twoFA.phoneNumberInvalidMessage"/>
            </div>
          ) : null}
        </div>
      ),
      footer: (
        <div className="TwoFactorAuth-popup-overlay-footer">
          <div className="TwoFactorAuth-popup-overlay-footer-actions">
            <div className="TwoFactorAuth-popup-overlay-footer-actions-button-back"
                 onClick={this.handleBackClick}>
              <FormattedMessage id="twoFA.backButton"/>
            </div>
            <div className="TwoFactorAuth-popup-overlay-footer-actions-button-green"
                 onClick={this.handleUpdatePhoneNumber}>
              <FormattedMessage id="twoFA.updateButton"/>
            </div>
          </div>
        </div>
      )
    };
  };

  closeButtonClick = () => {
    this.revertUserValues();
    this.props.onClose(true);
  }

  getDialog = () => {
    if (this.state.step < steps.Updated) {
      let content = this.getDialogContent();
      const popupStyles = browserIsSafari() && this.props.windowWidth < 991 ? {height: this.props.windowHeight - 35} : {};
      return (
        <div className={"TwoFactorAuth-popup-overlay-dialog TwoFactorAuth-popup-overlay-dialog--" + this.state.step} style={popupStyles}>
          <div className="TwoFactorAuth-popup-overlay-header">
            <div className="TwoFactorAuth-popup-overlay-title">{content.title}</div>
            <div className="TwoFactorAuth-popup-overlay-controlbox" onClick={this.closeButtonClick}>
              <span className="close-button">X</span>
            </div>
          </div>
          {content.content}
          {content.footer}
        </div>
      );
    } else {
      return (
        <div className="TwoFactorAuth-popup-overlay-dialog">
          <div className="TwoFactorAuth-popup-overlay-modal">
            <div className="TwoFactorAuth-popup-overlay-modal-content">
              <FormattedMessage id="twoFA.phoneNumber"/> <span
              className="TwoFactorAuth-popup-overlay-modal-action">
              <FormattedMessage id={this.state.step === steps.Updated ? "twoFA.updated" : "twoFA.verified"}/>
            </span>
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (store) => {
  const {phoneNumber, country} = store.userState.userInfo;
  return {
    phoneNumber,
    country,
  };
};

const mapDispatchToProps = {
  changeUserInfo,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(TwoFactorAuthClass)
)
